const topics = [
  {
    id: 'idx-1',
    title: '2026暑期档必看片单',
    desc: '精选暑期最值得观看的10部新片，从动作大片到文艺佳作一网打尽。',
    count: '18部',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20concept%2C%20cinema%20seats%20with%20popcorn%2C%20warm%20golden%20lighting%2C%20cozy%20atmosphere%2C%20film%20reel%20decoration%2C%20vibrant%20summer%20vibes%2C%20cinematic%20photography%20style&width=600&height=400&seq=juzi-index-01&orientation=landscape',
  },
  {
    id: 'idx-2',
    title: '国产科幻电影崛起之路',
    desc: '从《流浪地球》到《三体》，国产科幻电影的十年进化史。',
    count: '24部',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20film%20evolution%20concept%2C%20futuristic%20cityscape%20with%20traditional%20Chinese%20elements%2C%20neon%20and%20holographic%20displays%2C%20cyberpunk%20aesthetic%2C%20warm%20orange%20accents%2C%20cinematic%20wide%20shot&width=600&height=400&seq=juzi-index-02&orientation=landscape',
  },
  {
    id: 'idx-3',
    title: '悬疑烧脑剧深度盘点',
    desc: '反转再反转，智商碾压的极致体验。年度口碑悬疑剧全收录。',
    count: '15部',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20concept%2C%20detective%20desk%20with%20magnifying%20glass%20and%20case%20files%2C%20dim%20warm%20lamp%20light%2C%20noir%20atmosphere%2C%20shadow%20patterns%20on%20wall%2C%20suspenseful%20cinematic%20style&width=600&height=400&seq=juzi-index-03&orientation=landscape',
  },
  {
    id: 'idx-4',
    title: '经典港片修复重映合集',
    desc: '高清修复版经典港片，重温黄金时代的银幕记忆。',
    count: '32部',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20retro%20concept%2C%20old%20film%20posters%20on%20brick%20wall%2C%20vintage%20neon%20signs%2C%20warm%20nostalgic%20lighting%2C%20film%20camera%20vintage%20prop%2C%20golden%20age%20cinema%20aesthetic&width=600&height=400&seq=juzi-index-04&orientation=landscape',
  },
  {
    id: 'idx-5',
    title: '高分动画电影合家欢',
    desc: '适合全家一起观看的优质动画电影，画面精美故事动人。',
    count: '21部',
    img: 'https://readdy.ai/api/search-image?query=Animated%20family%20movie%20concept%2C%20colorful%20animation%20characters%20in%20magical%20forest%2C%20warm%20sunlight%20through%20trees%2C%20whimsical%20atmosphere%2C%20soft%20glowing%20particles%2C%20heartwarming%20cinematic%20style&width=600&height=400&seq=juzi-index-05&orientation=landscape',
  },
  {
    id: 'idx-6',
    title: '真实事件改编影视精选',
    desc: '源自真实、震撼人心。根据真实事件改编的高分影视作品专题。',
    count: '12部',
    img: 'https://readdy.ai/api/search-image?query=True%20story%20film%20concept%2C%20old%20typewriter%20with%20scattered%20photographs%2C%20warm%20sepia%20tones%2C%20vintage%20journalism%20aesthetic%2C%20dramatic%20window%20light%2C%20documentary%20style%20cinematic%20photography&width=600&height=400&seq=juzi-index-06&orientation=landscape',
  },
  {
    id: 'idx-7',
    title: '日韩高分剧集速递',
    desc: '最新上线的日韩热播剧一网打尽，豆瓣高分佳作持续更新。',
    count: '27部',
    img: 'https://readdy.ai/api/search-image?query=Korean%20Japanese%20drama%20collection%20concept%2C%20modern%20Seoul%20cityscape%20at%20twilight%2C%20warm%20city%20lights%2C%20cozy%20viewing%20setup%20with%20laptop%2C%20cinematic%20urban%20aesthetic%2C%20soft%20evening%20atmosphere&width=600&height=400&seq=juzi-index-07&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">专题合集</h2>
          <p className="text-foreground-500 text-sm mt-2">精心策划的影视专题，发现你的下一部好片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {topics.slice(0, 4).map((topic) => (
            <div
              key={topic.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className="text-foreground-100 font-bold text-sm">{topic.title}</h3>
                <p className="text-foreground-600 text-xs mt-1.5 leading-relaxed">{topic.desc}</p>
                <div className="flex items-center gap-1.5 mt-3">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[10px] font-medium whitespace-nowrap">
                    {topic.count}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          {topics.slice(4).map((topic) => (
            <div
              key={topic.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className="text-foreground-100 font-bold text-sm">{topic.title}</h3>
                <p className="text-foreground-600 text-xs mt-1.5 leading-relaxed">{topic.desc}</p>
                <div className="flex items-center gap-1.5 mt-3">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[10px] font-medium whitespace-nowrap">
                    {topic.count}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}